import { render, staticRenderFns } from "./IFValuationMultiples.vue?vue&type=template&id=be6f80a4"
import script from "./IFValuationMultiples.vue?vue&type=script&lang=js"
export * from "./IFValuationMultiples.vue?vue&type=script&lang=js"
import style0 from "./IFValuationMultiples.vue?vue&type=style&index=0&id=be6f80a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports